import type { FC } from 'react'

import AgentChatContent from './AgentChatContent'
import { useAgentChat } from './AgentChatContext'
import DraggableResizableWindow from './DraggableResizableWindow'

const FloatingChatWindow: FC = () => {
  const {
    closeChat,
    floatingPosition,
    updateFloatingPosition,
    floatingSize,
    updateFloatingSize,
    toggleChatMode,
  } = useAgentChat()

  return (
    <DraggableResizableWindow
      position={floatingPosition}
      size={floatingSize}
      onClose={closeChat}
      onPositionChange={updateFloatingPosition}
      onSizeChange={updateFloatingSize}
      onToggleMode={toggleChatMode}
    >
      <AgentChatContent />
    </DraggableResizableWindow>
  )
}

export default FloatingChatWindow
